import jsPDF from "jspdf";

const PAGE_MARGIN = 48;
const LINE_GAP = 6;
const SECTION_GAP = 14;

const slug = (s) =>
  String(s || "job-description")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 60) || "job-description";

const writeWrapped = (doc, text, x, y, maxWidth, lineHeight) => {
  const lines = doc.splitTextToSize(String(text ?? ""), maxWidth);
  for (const line of lines) {
    if (y > doc.internal.pageSize.getHeight() - PAGE_MARGIN) {
      doc.addPage();
      y = PAGE_MARGIN;
    }
    doc.text(line, x, y);
    y += lineHeight;
  }
  return y;
};

const writeBulletList = (doc, items, x, y, maxWidth, lineHeight) => {
  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  for (const item of items || []) {
    const wrapped = doc.splitTextToSize(String(item ?? ""), maxWidth - 14);
    wrapped.forEach((line, i) => {
      if (y > doc.internal.pageSize.getHeight() - PAGE_MARGIN) {
        doc.addPage();
        y = PAGE_MARGIN;
      }
      doc.text(i === 0 ? `•  ${line}` : `   ${line}`, x, y);
      y += lineHeight;
    });
    y += 2;
  }
  return y;
};

const writeSectionHeading = (doc, heading, x, y) => {
  if (y > doc.internal.pageSize.getHeight() - PAGE_MARGIN - 20) {
    doc.addPage();
    y = PAGE_MARGIN;
  }
  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.setTextColor(71, 85, 105);
  doc.text(String(heading || "").toUpperCase(), x, y);
  doc.setTextColor(15, 23, 42);
  return y + LINE_GAP + 6;
};

export const jdToPdfBlob = (jd) => {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const pageWidth = doc.internal.pageSize.getWidth();
  const contentWidth = pageWidth - PAGE_MARGIN * 2;

  let y = PAGE_MARGIN;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(20);
  doc.setTextColor(15, 23, 42);
  y = writeWrapped(doc, jd?.title || "Job Description", PAGE_MARGIN, y, contentWidth, 24);

  y += 4;

  if (jd?.overview) {
    doc.setFont("helvetica", "italic");
    doc.setFontSize(11);
    doc.setTextColor(51, 65, 85);
    y = writeWrapped(doc, jd.overview, PAGE_MARGIN, y, contentWidth, 16);
    doc.setTextColor(15, 23, 42);
    y += SECTION_GAP;
  }

  if (jd?.responsibilities?.length) {
    y = writeSectionHeading(doc, "Responsibilities", PAGE_MARGIN, y);
    y = writeBulletList(doc, jd.responsibilities, PAGE_MARGIN, y, contentWidth, 15);
    y += SECTION_GAP;
  }

  if (jd?.requirements?.length) {
    y = writeSectionHeading(doc, "Requirements", PAGE_MARGIN, y);
    y = writeBulletList(doc, jd.requirements, PAGE_MARGIN, y, contentWidth, 15);
    y += SECTION_GAP;
  }

  if (jd?.perks?.length) {
    y = writeSectionHeading(doc, "Perks", PAGE_MARGIN, y);
    y = writeBulletList(doc, jd.perks, PAGE_MARGIN, y, contentWidth, 15);
  }

  const blob = doc.output("blob");
  const fileName = `${slug(jd?.title)}-jd.pdf`;
  return new File([blob], fileName, { type: "application/pdf" });
};
